import { ImageData } from '@/lib/api/client'
import { useCADPageStore } from '@/state/cad'
import { IMAGE_DATA_VERSION } from '@/pages/CADPage/constants'

export const useImageData = (): ImageData => {
  const explosions = useCADPageStore((state) => state.explosions)
  const hiddenParts = useCADPageStore((state) => state.hiddenParts)
  const colorMap = useCADPageStore((state) => state.colorMap)
  const transparentParts = useCADPageStore((state) => state.transparentParts)
  const cameraAspect = useCADPageStore((state) => state.cameraAspect)
  const cameraPosition = useCADPageStore((state) => state.cameraPosition)
  const cameraFov = useCADPageStore((state) => state.cameraFov)
  const cameraZoom = useCADPageStore((state) => state.cameraZoom)
  const cameraQuaternion = useCADPageStore((state) => state.cameraQuaternion)
  const cameraUp = useCADPageStore((state) => state.cameraUp)
  const isExplosionLinesEnabled = useCADPageStore(
    (state) => state.isExplosionLinesEnabled,
  )
  const renderMode = useCADPageStore((state) => state.renderMode)
  const clippingPlanes = useCADPageStore((state) => state.clippingPlanes)
  const exclusiveCrossSectionMap = useCADPageStore(
    (state) => state.exclusiveCrossSectionMap,
  )
  const target = useCADPageStore((state) => state.target)
  const hidePreviousOperations = useCADPageStore(
    (state) => state.hidePreviousOperations,
  )
  const showFullModel = useCADPageStore((state) => state.showFullModel)

  const imageData: ImageData = {
    version: IMAGE_DATA_VERSION,
    cameraAspect,
    cameraPosition,
    cameraFov,
    cameraZoom,
    cameraQuaternion,
    cameraUp,
    explosions,
    hiddenParts,
    colorMap,
    transparentParts,
    isExplosionLinesEnabled,
    renderMode,
    clippingPlanes,
    exclusiveCrossSectionMap,
    target,
    hidePreviousOperations,
    showFullModel,
  }

  return imageData
}
